import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ApolloResponse1aeginapbuksm as ApolloResponse } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { withContextp2qc4rbktyej as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ProducerScopeb3mmhvfa6ll7 as ProducerScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { Builder3moivcm5iuump as Builder_1 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  flowOn2q2f1gsn1yu9y as flowOn,
  buffer2o7vhreze5nfc as buffer,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RetryOnErrorInterceptor28nn2rq891clj as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_channelFlow) {
        this.g62_1 = $this_channelFlow;
      }
      *h62(it, $completion) {
        yield* this.g62_1.s1a(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.h62(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0($this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda$slambda())($this_channelFlow);
  var l = (it, $completion) => i.h62(it, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing, $this_channelFlow) {
        this.i62_1 = this$0;
        this.j62_1 = $apolloRequest;
        this.k62_1 = $throwing;
        this.l62_1 = $this_channelFlow;
      }
      *r1f($this$withContext, $completion) {
        var tmp = this.i62_1.m62(this.j62_1, this.k62_1);
        var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0(this.l62_1);
        yield* tmp.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda_0(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda())(this$0, $apolloRequest, $throwing, $this_channelFlow);
  var l = ($this$withContext, $completion) => i.r1f($this$withContext, $completion);
  l.$arity = 1;
  return l;
}
var BuilderClass;
function Builder_2() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.n62_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.o62_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.p62_1 = ArrayList().p2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.q62_1 = ArrayList().p2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.r62_1 = ArrayList().p2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.s62_1 = ArrayList().p2();
        this.t62_1 = this.s62_1;
        var tmp_4 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_4.u62_1 = ArrayList().p2();
        this.v62_1 = this.u62_1;
        this.w62_1 = Companion_getInstance().d42_1;
        this.x62_1 = null;
        this.y62_1 = null;
        this.z62_1 = null;
        this.a63_1 = null;
        this.b63_1 = null;
        this.c63_1 = null;
        this.d63_1 = null;
        this.e63_1 = null;
        this.f63_1 = null;
        this.g63_1 = null;
        this.h63_1 = null;
        this.i63_1 = null;
        this.j63_1 = null;
        this.k63_1 = null;
        this.l63_1 = null;
        this.m63_1 = null;
        this.n63_1 = null;
        this.o63_1 = null;
        this.p63_1 = null;
        this.q63_1 = null;
        this.r63_1 = null;
        this.s63_1 = null;
        this.t63_1 = null;
        this.u63_1 = true;
      }
      v63() {
        return this.n62_1.y36();
      }
      w63() {
        return plus(plus(plus(this.o62_1, this.p62_1), this.q62_1), this.r62_1);
      }
      q42(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.u63_1 = sendEnhancedClientAwareness;
        return this;
      }
      p42(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.r63_1 = failFastIfOffline;
        return this;
      }
      x63(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.p63_1 = retryOnError;
        return this;
      }
      y63(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.q63_1 = retryOnErrorInterceptor;
        return this;
      }
      z63(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.s63_1 = cacheInterceptor;
        return this;
      }
      a64(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.t63_1 = autoPersistedQueryInterceptor;
        return this;
      }
      h42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.x62_1 = httpMethod;
        return this;
      }
      i42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.y62_1 = httpHeaders;
        return this;
      }
      k42(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.z62_1 = sendApqExtensions;
        return this;
      }
      l42(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.a63_1 = sendDocument;
        return this;
      }
      m42(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.b63_1 = enableAutoPersistedQueries;
        return this;
      }
      n42(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.c63_1 = canBeBatched;
        return this;
      }
      b64(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.g63_1 = serverUrl;
        return this;
      }
      c64(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.g63_1 = httpServerUrl;
        return this;
      }
      d64(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.h63_1 = httpEngine;
        return this;
      }
      e64(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.l63_1 = httpExposeErrorBody;
        return this;
      }
      f64(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.s62_1.a5();
        this.s62_1.u2(httpInterceptors);
        return this;
      }
      g64(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.i63_1 = webSocketServerUrl;
        return this;
      }
      h64(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.o63_1 = webSocketServerUrl;
        return this;
      }
      i64(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.j63_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      j64(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.k63_1 = wsProtocolFactory;
        return this;
      }
      k64(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.m63_1 = webSocketEngine;
        return this;
      }
      l64(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.n63_1 = webSocketReopenWhen;
        return this;
      }
      m64(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.d63_1 = networkTransport;
        return this;
      }
      n64(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.e63_1 = subscriptionNetworkTransport;
        return this;
      }
      o64(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.n62_1.a5();
        this.n62_1.t45(customScalarAdapters);
        return this;
      }
      p64(listeners) {
        // Inline function 'kotlin.apply' call
        this.u62_1.a5();
        this.u62_1.u2(listeners);
        return this;
      }
      q64(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.f63_1 = dispatcher;
        return this;
      }
      f42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.w62_1 = executionContext;
        return this;
      }
      y36() {
        return new (ApolloClient())(this.t37());
      }
      t37() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_2())()).o64(this.n62_1.y36());
        this_0.o62_1.u2(this.o62_1);
        this_0.p62_1.u2(this.p62_1);
        this_0.q62_1.u2(this.q62_1);
        this_0.r62_1.u2(this.r62_1);
        return this_0.q64(this.f63_1).f42(this.w62_1).h42(this.x62_1).i42(this.y62_1).c64(this.g63_1).d64(this.h63_1).e64(this.l63_1).f64(this.t62_1).k42(this.z62_1).l42(this.a63_1).m42(this.b63_1).n42(this.c63_1).m64(this.d63_1).n64(this.e63_1).g64(this.i63_1).h64(this.o63_1).k64(this.m63_1).l64(this.n63_1).i64(this.j63_1).j64(this.k63_1).x63(this.p63_1).y63(this.q63_1).z63(this.s63_1).a64(this.t63_1).p42(this.r63_1).p64(this.v62_1).q42(this.u63_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_2);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.r64_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.r64_1(value, $completion);
      }
      i5() {
        return this.r64_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var ApolloClient$executeAsFlowInternal$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing) {
        this.s64_1 = this$0;
        this.t64_1 = $apolloRequest;
        this.u64_1 = $throwing;
      }
      *v64($this$channelFlow, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.s64_1.u61_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.w64(this.t64_1);
        }
        try {
          yield* withContext(this.s64_1.k61_1.x64_1, ApolloClient$executeAsFlowInternal$slambda$slambda_0(this.s64_1, this.t64_1, this.u64_1, $this$channelFlow), $completion);
        }finally {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = this.s64_1.u61_1.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var element_0 = _iterator__ex2g4s_0.r1();
            element_0.z64(this.t64_1);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.v64((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda_0(this$0, $apolloRequest, $throwing) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda())(this$0, $apolloRequest, $throwing);
  var l = ($this$channelFlow, $completion) => i.v64($this$channelFlow, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$apolloResponses$slambdaClass;
function ApolloClient$apolloResponses$slambda() {
  if (ApolloClient$apolloResponses$slambdaClass === VOID) {
    class $ {
      *h62(response, $completion) {
        if (!(response.b44_1 == null)) {
          throw ensureNotNull(response.b44_1);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.h62(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$apolloResponses$slambdaClass = $;
  }
  return ApolloClient$apolloResponses$slambdaClass;
}
function ApolloClient$apolloResponses$slambda_0() {
  var i = new (ApolloClient$apolloResponses$slambda())();
  var l = (response, $completion) => i.h62(response, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.j61_1 = builder;
        this.n61_1 = this.j61_1.w63();
        this.o61_1 = this.j61_1.v63();
        this.p61_1 = this.j61_1.s63_1;
        this.q61_1 = this.j61_1.t63_1;
        this.r61_1 = this.j61_1.p63_1;
        this.s61_1 = this.j61_1.q63_1;
        this.t61_1 = this.j61_1.r63_1;
        this.u61_1 = this.j61_1.v62_1;
        this.v61_1 = this.j61_1.u63_1;
        this.w61_1 = this.j61_1.w62_1;
        this.x61_1 = this.j61_1.x62_1;
        this.y61_1 = this.j61_1.y62_1;
        this.z61_1 = this.j61_1.z62_1;
        this.a62_1 = this.j61_1.a63_1;
        this.b62_1 = this.j61_1.b63_1;
        this.c62_1 = this.j61_1.c63_1;
        var tmp = this;
        var tmp_0;
        if (!(this.j61_1.d63_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.g63_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.h63_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.j61_1.t62_1.n1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.l63_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.j61_1.d63_1);
        } else {
          // Inline function 'kotlin.check' call
          if (!!(this.j61_1.g63_1 == null)) {
            var message_3 = "Apollo: 'serverUrl' is required";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).b64(ensureNotNull(this.j61_1.g63_1));
          if (!(this.j61_1.h63_1 == null)) {
            this_0.g65(ensureNotNull(this.j61_1.h63_1));
          }
          if (!(this.j61_1.l63_1 == null)) {
            this_0.h65(ensureNotNull(this.j61_1.l63_1));
          }
          tmp_0 = this_0.i65(this.j61_1.t62_1).y36();
        }
        tmp.l61_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.j61_1.e63_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.i63_1 == null)) {
            var message_4 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.m63_1 == null)) {
            var message_5 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.j63_1 == null)) {
            var message_6 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.k63_1 == null)) {
            var message_7 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.n63_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          // Inline function 'kotlin.check' call
          if (!(this.j61_1.o63_1 == null)) {
            var message_9 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_9));
          }
          tmp_2 = ensureNotNull(this.j61_1.e63_1);
        } else {
          var tmp0_elvis_lhs = this.j61_1.i63_1;
          var url = tmp0_elvis_lhs == null ? this.j61_1.g63_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.l61_1;
          } else {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_1())()).b64(url);
            if (!(this.j61_1.m63_1 == null)) {
              this_1.p65(ensureNotNull(this.j61_1.m63_1));
            }
            if (!(this.j61_1.j63_1 == null)) {
              this_1.q65(ensureNotNull(this.j61_1.j63_1));
            }
            if (!(this.j61_1.k63_1 == null)) {
              this_1.r65(ensureNotNull(this.j61_1.k63_1));
            }
            if (!(this.j61_1.n63_1 == null)) {
              this_1.s65(this.j61_1.n63_1);
            }
            if (!(this.j61_1.o63_1 == null)) {
              this_1.t65(this.j61_1.o63_1);
            }
            tmp_3 = this_1.y36();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.m61_1 = tmp_2;
        var tmp1_elvis_lhs = this.j61_1.f63_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.k61_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope_0(dispatcher));
        this.d62_1 = new (NetworkInterceptor())(this.l61_1, this.m61_1);
      }
      u65(query) {
        return ApolloCall().h61(this, query);
      }
      v65(mutation) {
        return ApolloCall().h61(this, mutation);
      }
      l6() {
        cancel(this.k61_1.y64_1);
        this.l61_1.jz();
        this.m61_1.jz();
      }
      e62(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda_0(this, apolloRequest, throwing));
        return buffer(flowOn(flow, Dispatchers_getInstance().y12_1), 2147483647);
      }
      m62(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.e43();
        this_0.f42(this.k61_1.r43(this.o61_1).r43(apolloClient.w61_1).r43(this_0.s41_1));
        var tmp0_elvis_lhs = this_0.t41_1;
        this_0.h42(tmp0_elvis_lhs == null ? apolloClient.x61_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.w41_1;
        this_0.k42(tmp1_elvis_lhs == null ? apolloClient.z61_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.x41_1;
        this_0.l42(tmp2_elvis_lhs == null ? apolloClient.a62_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.v41_1;
        this_0.m42(tmp3_elvis_lhs == null ? apolloClient.b62_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().p2();
        if (!(this_0.z41_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.y61_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.u2(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.u41_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.u2(tmp$ret$7);
        var headers = this_1.f8();
        this_0.i42(headers);
        var tmp4_elvis_lhs = this_0.y41_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.c62_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.j42('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.a42_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.r61_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.o42(tmp);
        var tmp7_elvis_lhs = this_0.b42_1;
        this_0.p42(tmp7_elvis_lhs == null ? apolloClient.t61_1 : tmp7_elvis_lhs);
        this_0.q42(apolloClient.v61_1);
        var request = this_0.y36();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_2 = ArrayList().p2();
        this_2.u2(this.j61_1.o62_1);
        if (!(this.p61_1 == null)) {
          this_2.i2(this.p61_1);
        }
        this_2.u2(this.j61_1.p62_1);
        if (!(this.q61_1 == null)) {
          this_2.i2(this.q61_1);
        }
        this_2.u2(this.j61_1.q62_1);
        var tmp0_elvis_lhs_2 = this.s61_1;
        this_2.i2(tmp0_elvis_lhs_2 == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs_2);
        this_2.u2(this.j61_1.r62_1);
        this_2.i2(this.d62_1);
        var allInterceptors = this_2.f8();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(allInterceptors, 0)).y65(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda_0());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_2 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
